
define('template!groupsLayoutTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="hbox folders-container">\n\t<aside class="groups-column-container">\n\t\t';
 if (showAddButton) { ;
__p += '\n\t\t\t<div class="add-new-block">\n\t\t\t  <div class="btn js-add-new add-btn-text">\n\t\t\t    <i class="mdi-content-add icon"></i>\n          <span>' +
((__t = ( _.i18n('common.new') )) == null ? '' : __t) +
'</span>\n\t\t\t  </div>\n\t\t\t</div>\n\t\t';
 } ;
__p += '\n\t\t\n\t\t<div id="groups-column" class="groups-column"></div>\n\t</aside>\n\t<section class="elements-column-container">\n\t\t<div id="elements-column" class="elements-column vbox"></div>\n\t</section>\n</div>';

}
return __p
};});

